import {
    Button,
    Input,
    InputNumber,
    Radio,
    Typography,
    Space,
    Modal,
    Row,
    Col,
    Segmented,
    Form
} from "antd";
import { MinusOutlined, PlusOutlined } from "@ant-design/icons";
import { useEffect, useState, useContext } from "react";
import { PublicContext } from "../PublicContext";
import "../../styles/custom.css";
import { useNavigate } from "react-router-dom";

export default function TipsModal({ visible, onCancel, onSubmit }) {
    const navigate = useNavigate();
    const { cart, deliveryOrPickUp } = useContext(PublicContext);
    const [tips, setTips] = useState((cart[0].orderSubtotal * 0.12).toFixed(2));
    const [customTips, setCustomTips] = useState((cart[0].orderSubtotal * 0.12).toFixed(2));
    const [tipsMode, setTipsMode] = useState("b");
    const { Title } = Typography;

    useEffect(() => {
        sessionStorage.setItem("tips", (cart[0].orderSubtotal * 0.12).toFixed(2));
    }, []);

    const handleTipsChange = (value) => {
        sessionStorage.setItem("tips", value ? Number(value).toFixed(2) : 0);
        setCustomTips(value ? Number(value).toFixed(2) : 0);
        setTips(value ? Number(value).toFixed(2) : 0); // Set the tips value to the changed value
    };

    const formItemLayout = {
        labelCol: {
            xs: {
                span: 7,
            },
            sm: {
                span: 5,
            },
        },
        wrapperCol: {
            xs: {
                span: 10,
            },
            sm: {
                span: 10,
            },
        },
    };

    return (
        <Modal
            title={
                <Typography.Title level={2}>Show your support with a tip</Typography.Title>
            }
            footer={
                <div style={{ textAlign: 'center' }}>
                    <Typography.Title level={5}>Tips: <strong>${tips}</strong></Typography.Title>
                    <Button
                        className="upsellCheckout-btn btn-primary"
                        shape="round"
                        onClick={onSubmit}
                    >
                        Place {deliveryOrPickUp === "delivery" ? "Delivery Order" : "Pickup Order"}
                    </Button>
                </div>
            }
            open={visible}
            onCancel={onCancel}
            scrollable={true}
            // key={placement}
            className="tipsModal"
        >
            <Typography.Title level={5} tag="h5" className="fw-bold mb-0 text-black">
                Tips are based on your order total of ${cart[0].orderSubtotal} before any discounts or promotions.
            </Typography.Title>
            <Radio.Group value={tipsMode} onChange={(e) => setTipsMode(e.target.value)} className="vertical-tip-radio-group" styles={{ width: "100%" }}>
                <Radio.Button value="a" onClick={() => {
                    sessionStorage.setItem("tips", (cart[0].orderSubtotal * 0.10).toFixed(2));
                    setTips((cart[0].orderSubtotal * 0.10).toFixed(2));
                    //handleSetScheduleDateTime();
                }}>
                    <Typography>
                        10%
                    </Typography>
                </Radio.Button>

                <Radio.Button value="b" onClick={() => {
                    sessionStorage.setItem("tips", (cart[0].orderSubtotal * 0.12).toFixed(2));
                    setTips((cart[0].orderSubtotal * 0.12).toFixed(2));
                    //handleSetScheduleDateTime();
                }}>
                    <Typography>
                        12%
                    </Typography>
                </Radio.Button>

                <Radio.Button value="c" onClick={() => {
                    sessionStorage.setItem("tips", (cart[0].orderSubtotal * 0.15).toFixed(2));
                    setTips((cart[0].orderSubtotal * 0.15).toFixed(2));
                    //handleSetScheduleDateTime();
                }}>
                    <Typography>
                        15%
                    </Typography>
                </Radio.Button>

                <Radio.Button value="d" onClick={() => {
                    sessionStorage.setItem("tips", customTips);
                    setTips(customTips);
                    //handleSetScheduleDateTime();
                }}>
                    <Typography style={{ marginBottom: '0px' }}>
                        Custom
                    </Typography>
                </Radio.Button>

                <Radio.Button value="e" onClick={() => {
                    sessionStorage.setItem("tips", 0);
                    setTips(0);
                    //handleSetScheduleDateTime();
                }}>
                    <Typography>
                        No Tips
                    </Typography>
                </Radio.Button>
            </Radio.Group>
            {
                tipsMode === "d" &&
                <Form
                        layout="horizontal"
                        variant="filled"
                        {...formItemLayout}
                        style={{padding: "5px"}}
                    >
                        <Form.Item
                            label="Custom Tips"
                        >
                            <InputNumber prefix="$"
                                min={0}
                                step="0.01"
                                placeholder={0.00}
                                value={customTips}
                                variant="filled"
                                stringMode
                                onClick={() => {
                                    setTipsMode("d");
                                    handleTipsChange(customTips);
                                }}
                                onChange={handleTipsChange}
                            />
                        </Form.Item>
                        
                </Form>
            }
        </Modal>
    );
}